module.exports = __webpack_public_path__ + "static/media/logout-icon.4cfd1f69.svg";